import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import includes from 'lodash/includes';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import {Redirect} from 'react-router-dom';
import {Types as ResourceTypes} from "../../api/resources";
import {getUserBreakTypes, getUserGroupName} from 'pages/Profile/selectors';
import CreateBreakFormModal from '../../components/break/CreateBreakFormModal';
import createBreakFormConfig from "../../components/break/createBreakFormConfig";
import {endCreateChallengeAction, submitCreateChallenge, updateChallengeParams} from "./actions";
import {UserGroups} from 'utils/DBUtils';

const disableSponsoredType = field => field.name === 'sponsoredType' ? {...field, disabled: true} : field;

const mapStateToProps = state => {
    const sponsoredBreaksAllowed = includes(getUserBreakTypes(state), 'sponsored');

    const formConfig = sponsoredBreaksAllowed ? createBreakFormConfig : {
        ...createBreakFormConfig,
        fields: createBreakFormConfig.fields.map(disableSponsoredType)
    };

    return {
        formConfig,
        formData: state.createChallenge.challengeParams,
        modalOpen: state.createChallenge.creatingChallenge,
        creationError: state.createChallenge.error
    };
};

const mapDispatchToProps = dispatch => bindActionCreators({
    onValueChanged: updateChallengeParams,
    submit: data => submitCreateChallenge(data.permalink, data.sponsoredType, data.lang, data.hub),
    handleClose: endCreateChallengeAction
}, dispatch);

const CreateBreakModalContainerConnected = connect(mapStateToProps, mapDispatchToProps);

const CreateBreakModalLifeCycle = lifecycle({
    componentWillUnmount: function () {
        this.props.handleClose();
    }
});

const CreateBreakModalContainer = compose(
    CreateBreakModalContainerConnected,
    CreateBreakModalLifeCycle,
)(CreateBreakFormModal);

// TODO: Current version of react-router-redux wasn't working, try next version is release
/**
 * Quick redirect container based on whether a createdChallengeId exists
 */
const CreateBreakModalRedirectContainer = connect((state) => ({
    createdChallengeId: state.createChallenge.createdChallengeId
}), null)((props) => (
    <div>
        {props.createdChallengeId ? <Redirect to={`/break/${props.createdChallengeId}/edit`}/> : ""}
    </div>
));

/**
 * Render modal and redirect separately because modal gets hidden when create is pressed.
 * Separation makes sure redirect can actually be rendered.
 */
const CreateBreakModalContainerGroup = () => [
    <CreateBreakModalContainer key="CreateBreakModalContainer"/>,
    <CreateBreakModalRedirectContainer key="CreateBreakModalRedirect"/>
];

export default CreateBreakModalContainerGroup;



// WEBPACK FOOTER //
// ./public/pages/BreakCreator/CreateBreakModalContainer.jsx